import nomesBonitosCategoria from "./nomesBonitosCategoria";

/**
 * Devolve o nome formatado de uma categoria a partir do slug.
 * Se houver no dicionário personalizado, usa esse valor.
 * Caso contrário, gera um nome bonito automaticamente.
 */
export default function obterNomeCategoria(slug) {
  if (!slug) return "";

  // 1. Tenta encontrar no dicionário
  if (nomesBonitosCategoria[slug]) {
    return nomesBonitosCategoria[slug];
  }

  // 2. Caso não encontre, formata automaticamente (ex: melhorfilmeinternacional → Melhorfilmeinternacional)
  return slug
    .replace(/-/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .replace(/\b\w/g, l => l.toUpperCase());
}